import styled from '@emotion/styled'

export const Form = styled.form`
  margin-top: 2em;
`

export const Columns = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0 1em;
  justify-content: space-between;
  flex-wrap: wrap;
`

export const Buttons = styled.div`
  display: flex;
  align-items: center;
  gap: 1em;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 1em;
`
